import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bind } from '@mdigital/components/dist/decorators';
import Select from '@mdigital/components/dist/components/Select';
import { Select as AlchemySelect } from '@m/alchemy-ui';
import WarningSvg from '../../assets/General/warning.svg';
import withProvider from '../../hoc/ProviderHoc';
import { getResourceById, checkProvision } from '../../../redux/store/store-helper';
import { PROVISIONS } from '../../../common/enums';
import { getDeployedResources } from './resourcesSelectors';
import { dynamicObjectArraySort } from '../../../common/utils';
const NONE = 'None';
function mapStateToProps(state) {
  const { resources } = state;
  return {
    allResources: resources.allResources || [],
    deployedResources: getDeployedResources(state),
  };
}

function formatResourceToOption({ id, fileName }) {
  return { value: id, label: fileName };
}

function filterByType(resources, types = []) {
  return (resources || []).filter(({ fileType }) => types.includes(fileType));
}

const EMPTY_RESOURCE = {
  resourceId: null,
  url: null,
  fileName: NONE,
  name: NONE,
};

const EMPTY_OPTION = {
  value: NONE,
  label: NONE,
  resourceId: null,
};

export class ResourcesSelect extends React.Component {

  static propTypes = {
    placeholder: PropTypes.string,
    noOptionsHeader: PropTypes.string,
    onSelect: PropTypes.func,
    resourceId: PropTypes.number,
    types: PropTypes.arrayOf(PropTypes.string),
    isDisabled: PropTypes.bool,
    isShowAllResources: PropTypes.bool, // is survey-draft
    isAlchemyDesign: PropTypes.bool,
  };

  @bind
  selectionHandler({ value }) {
    const resource = value === NONE ? EMPTY_RESOURCE : getResourceById(value);
    this.props.onSelect(resource);
  }

  render() {
    const isDHH = checkProvision(PROVISIONS.DYNAMIC_HYBRID_HOSTING);
    const resources = this.props.isShowAllResources || !isDHH ? this.props.allResources : this.props.deployedResources;
    const shouldShowAlertForNonPublishedResources = this.props.isShowAllResources && isDHH;
    const currentResource = getResourceById(this.props.resourceId);
    const filteredResources = filterByType(resources, this.props.types);

    let options = [];
    const selectedOption = currentResource ? {
      value: this.props.resourceId,
      label: currentResource.fileName,
      ...(currentResource.isDeployed === false && { icon: WarningSvg }),
    } : null;

    if (filteredResources.length) {
      if (shouldShowAlertForNonPublishedResources) {
        // Separate deployed and draft resources
        const deployedResources = filteredResources.filter((r) => r.isDeployed);
        const draftResources = filteredResources.filter((r) => !r.isDeployed);

        // Add deployed resources
        if (deployedResources.length) {
          const deployedOptions = deployedResources
            .map(formatResourceToOption)
            .sort(dynamicObjectArraySort('label', 'asc'));

          options = this.props.types.includes('zip')
            ? deployedOptions
            : [EMPTY_OPTION, ...deployedOptions];
        } else if (!this.props.types.includes('zip')) {
          options = [EMPTY_OPTION];
        }

        // Add draft resources as a group
        if (draftResources.length) {
          const draftOptions = draftResources
            .map((resource) => ({
              ...formatResourceToOption(resource),
              icon: WarningSvg,
              isDeployed: false,
            }))
            .sort(dynamicObjectArraySort('label', 'asc'));

          options.push({
            label: 'Draft Resources',
            options: draftOptions,
          });
        }
      } else {
        // Original logic for non-DHH or deployed-only view
        const sortedOptions = filteredResources
          .map(formatResourceToOption)
          .sort(dynamicObjectArraySort('label', 'asc'));

        options = this.props.types.includes('zip')
          ? sortedOptions
          : [EMPTY_OPTION, ...sortedOptions];
      }
    }
    return (
      <React.Fragment>
        {this.props.isAlchemyDesign ?
          <AlchemySelect
            value={currentResource && selectedOption.value || NONE}
            options={options}
            placeholder={this.props.placeholder}
            disabled={this.props.isDisabled}
            onChange={this.selectionHandler}/>
          :
          <Select
            selected={selectedOption}
            options={options}
            placeholderText={this.props.placeholder}
            noOptionsHeader={this.props.noOptionsHeader}
            isDisabled={this.props.isDisabled}
            onSelect={this.selectionHandler}/>
        }
      </React.Fragment>
    );
  }
}

export default withProvider()(connect(mapStateToProps)(ResourcesSelect));
